import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import CustomTreeTable from '../../../../components/table/CustomTreeTable'
import AddZone from './AddZone'
import EditZone from './EditZone'
import SinglePagenation from '../../../../components/general/pagination/SinglePagenation'
import ListMaterial from '../../products/movements/ListMaterial'
import AddZoneType from '../zone-type/AddZoneType'
import ShowZoneType from '../zone-type/ShowZoneType'
import { v4 as uuidv4 } from 'uuid';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { loadWarehouses } from '../../../../store/Actions/ActionWarehouses'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { deleteZone, emptyZonesByWarehouse, loadZonesByWarehouse, setLoadZoneWithoutWarehouseId } from '../../../../store/Actions/ActionZone'
import InnerLoader from '../../../../components/general/inner-loader/InnerLoader'
import TabsSkeleton from '../../../../components/general/general-component/skeleton-components/TabsSkeleton'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'

const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
        {
            breakpoint: 1254,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 860,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 587,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        }

    ]
};


function ZonesShow() {
    const [currentPage, setCurrentPage] = useState(1)
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const { warehouses, loadingWarehouses, zoneWarehouse, loadingZoneWarehouse } = useSelectorCustom()
    const { translate } = AbstructLang()
    const [data, setData] = useState([])
    const { dispatch, langLocal, navigate } = AbstructVar()
    const [warehouse_id, setwarehouse_id] = useState(null)
    const [open, setOpen] = useState(false)
    const [open1, setOpen1] = useState(false)
    const [zone_id, setzone_id] = useState(null)
    const [editObj, setEditObj] = useState(null)
    const [isAdd, setIsAdd] = useState(false)
    const [objAdded, setObjAdded] = useState(null)
    const [openMaterial, setOpenMaterial] = useState(false)
    const [zone_idMat, setzone_idMat] = useState(null)
    const [zone_type_arr, setzone_type_arr] = useState([])
    const [zone_type, setzone_type] = useState('')
    const [symbol, setsymbol] = useState('')
    const [isZone_type, setIsZone_type] = useState(false)
    const handleSectionClick = (sectionId) => {
        setwarehouse_id(sectionId);
    };
    const generateUniqueId = () => {
        return uuidv4();
    };
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected + 1);
    };
    const handleDelete = (id) => {
        dispatch(deleteZone(id,warehouse_id, setloadDel));
    }
    const addObjToSubZonesRecursive = (zones, zoneId, objAdded) => {
        console.log(objAdded)
        return zones.map(zone => {
            if (zone.id === zoneId) {
                return {
                    ...zone,
                    sub_zones: zone.sub_zones ? [...zone.sub_zones, objAdded] : [objAdded]
                };
            } else if (zone.sub_zones) {
                return {
                    ...zone,
                    sub_zones: addObjToSubZonesRecursive(zone.sub_zones, zoneId, objAdded)
                };
            }
            return zone;
        });
    };

    const updateDataWithAddedObj = () => {
        console.log(objAdded)
        if (objAdded && zone_id) {
            const updatedData = addObjToSubZonesRecursive(data.data, zone_id, objAdded);
            console.log(updatedData)
            setData({ ...data, data: updatedData });
            setObjAdded(null)
        }
    };
    useEffect(() => {
        if (isAdd === true) {
            updateDataWithAddedObj();
        }
    }, [objAdded, zone_id]);
    const addToZoneType = () => {
        console.log('isZone_type2')
        const newZoneType = {
            id: generateUniqueId(),
            zone_type: zone_type,
            symbol: symbol
        };
        console.log(newZoneType)
        setzone_type_arr(prevArr => [...prevArr, newZoneType]);
        setzone_type('')
        setsymbol('')
        setIsZone_type(false)
    }
    const deleteZoneType = (id) => {
        const updatedArr = [...zone_type_arr];
        const indexToDelete = updatedArr.findIndex(item => item.id === id);
        if (indexToDelete !== -1) {
            updatedArr.splice(indexToDelete, 1);
            setzone_type_arr(updatedArr);
        }
    }
    useEffect(() => {
        console.log('isZone_type')
        if (isZone_type === true && zone_type != '' && symbol != '') {
            console.log('isZone_type1')
            addToZoneType();
        }
    }, [zone_type, symbol, isZone_type]);
    useEffect(() => {
        dispatch(loadWarehouses())
    }, [])
    useEffect(() => {
        if(warehouse_id === null){
            dispatch(setLoadZoneWithoutWarehouseId())
        }
        if (warehouse_id !== null) {
            dispatch(emptyZonesByWarehouse())
            dispatch(loadZonesByWarehouse(warehouse_id))
        }
    }, [warehouse_id])
    useEffect(() => {
        if (warehouses && warehouses?.length != 0) {
            //dispatch(loadZonesByWarehouse(warehouses[0]?.id))
            setwarehouse_id(warehouses[0]?.id)
        }
    }, [warehouses])
    const columns = [translate('select'), translate('name'), translate('symbol'), translate('materials'), translate('actions')];
    return (
        <>
            <div style={{ margin: '15px 0px' }} >
                {
                    !loadingWarehouses ? (
                        <Slider {...settings} className='silder22' style={{direction: `${langLocal === 'ar' ? "rtl":"ltr"}`}} >
                            {
                                warehouses?.map((warehouse) => {
                                    return (
                                        <div className={`${warehouse?.id === warehouse_id ? 'tabs-two-active1' : "tabs-two-div"} `} key={warehouse?.id} onClick={() => setwarehouse_id(warehouse?.id)} >
                                            {warehouse?.name}
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                    ) : <TabsSkeleton langLocal={langLocal} />
                }

                <div style={{ padding: '10px 20px' }} >
                    <AddZoneType warehouse_id={warehouse_id} translate={translate} />
                </div>
                <div style={{ padding: '10px 20px' }} >
                    <ShowZoneType langLocal={langLocal} translate={translate} deleteZoneType={deleteZoneType} zone_type_arr={zone_type_arr} />
                </div>
                <div className='config-warehouse-right'>
                    <div style={{ marginTop: "-35px" }} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('zones')} titleBtn={translate('add_zone')} FunctionBtn={() => setOpen(true)} />
                    </div>
                    {
                        !loadingZoneWarehouse ?
                            <>
                                <CustomTreeTable warning={warning} langLocal={langLocal} translate={translate} setOpenMaterial={setOpenMaterial} setzone_idMat={setzone_idMat} columns={columns} data={zoneWarehouse} open={open} setOpen={setOpen} setOpen1={setOpen1} setzone_id={setzone_id} setEditObj={setEditObj} />
                                {data.total > 0 && (
                                    <SinglePagenation pageCount={Math.ceil(data.total / 10)} changePage={handlePageChange} />
                                )}
                            </> : <InnerLoader />
                    }

                </div>
            </div>
            {
                open && (
                    <AddZone setIsAdd={setIsAdd} setObjAdded={setObjAdded} open={open} setOpen={setOpen} zone_id={zone_id} warehouse_id={warehouse_id} />
                )
            }
            {
                open1 && (
                    <EditZone zone_id={zone_id} editObj={editObj} open={open1} setOpen={setOpen1} warehouse_id={warehouse_id} />
                )
            }
            {
                openMaterial && (
                    <ListMaterial zone_idMat={zone_idMat} open={openMaterial} setOpen={setOpenMaterial} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
        </>
    )
}

export default ZonesShow